import React from 'react';

interface AffirmCalloutProps {
    pageType: string;
    price: number;
}

const AffirmCallout: React.FC<AffirmCalloutProps> = ({ pageType, price }) => {
    return <p className="affirm-as-low-as" data-page-type={pageType} data-amount={price}></p>;
};

export { AffirmCallout };
